import type { ProductConfigDefinition } from 'Models/uiConfig/productConfig.types';

export default {
  fields: {
    id: 'CatalogID',
    image: 'ThumbnailFile',
    title: 'Name',
    url: 'ProductLink',
  },
  getItemId: (): string =>
    window.document.querySelector<HTMLInputElement>('input#catalogid[name="item_id"]')!.value,
  getVariantId: (): undefined => undefined,
} satisfies ProductConfigDefinition;
